<template>
  <Bar />
  <div class="background">
    <div class="servers">
      <br />
      <div class="server-list">
        <div v-for="server in servers" :key="server.id" class="server-card">
          <h2>{{ server.name }}</h2>
          <p v-if="server.description" class="description">{{ server.description }}</p>
          <p><span>Memory:</span> {{ server.memory === 0 ? 'Unlimited' : `${server.memory}MB` }}</p>
          <p><span>Disk:</span> {{ server.disk === 0 ? 'Unlimited' : `${server.disk}MB` }}</p>
          <p><span>CPU:</span> {{ server.cpu === 0 ? 'Unlimited' : `${server.cpu}%` }}</p>
          <p><span>Location:</span> {{ server.node }}</p>
          <div class="actions">
            <button class="server-button"
              @click="openInNewTab(`https://panel.apfel-hosting.de/server/${server.uuidShort}`)">
              Open
            </button>
            <button class="delete-button"
              @click="toggleConfirmWindow(server.id)">
              <img src="@/assets/trash.png" alt="trash">
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="confirmWindowOpen" class="popup-overlay" @click="handleOverlayClick">
      <div class="confirm-popup" ref="popup">
        <h3>Confirm Deletion</h3>
        <p>Are you sure you want to delete this server?</p>
        <div class="popup-actions">
          <button class="confirm-button" @click="deleteS(deleteServerId)">Yes, Delete</button>
          <button class="cancel-button" @click="toggleConfirmWindow()">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import Bar from '@/components/Bar.vue';
import { deleteServer, getServerData } from '@/composables/api';
import router from '@/router';
import { updateStoreData } from '@/composables/store';

const store = useStore();
const servers = ref([]);
const confirmWindowOpen = ref(false);
const deleteServerId = ref(null);
const popup = ref(null);

const toggleConfirmWindow = (id = null) => {
  confirmWindowOpen.value = !confirmWindowOpen.value;
  deleteServerId.value = id;
};

const handleOverlayClick = (event) => {
  if (popup.value && !popup.value.contains(event.target)) {
    toggleConfirmWindow();
  }
};

const openInNewTab = (url) => {
  window.open(url, '_blank');
};

const deleteS = async (id) => {
  const code = await deleteServer(id);
  if (code.code === 200) {
    servers.value = servers.value.filter(server => parseInt(server.id) !== parseInt(id));
    toggleConfirmWindow();
  } else if ([401, 403, 404].includes(code.code)) {
    router.push("/servers");
  }
};

onMounted(async () => {
  const success = await updateStoreData();
  if (!success) {
    router.push('/login');
    return;
  }
  const result = await getServerData();
  if (!result.success) {
    router.push('/login');
  } else {
    servers.value = result.servers;
  }
});
</script>

<style>
.servers {
  padding-top: 100px;
  text-align: center;
  min-height: 100vh;
  transition: margin-left 0.3s ease, width 0.3s ease;
  margin-left: calc(var(--sidebar-width));
}

.server-list {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
}

.server-card {
  background-color: #F9FCFF;
  border: 1px solid #E7F1FF;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 20px;
  text-align: center;
  width: 200px;
  transition: transform 0.2s, box-shadow 0.2s;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.server-card h2 {
  color: #333;
  font-size: 18px;
  margin-bottom: 10px;
  word-break: break-word;
}

.server-button,
.delete-button {
  flex-grow: 1;
}

.server-button {
  background-color: #4CAF50;
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
  height: 48px;
  width: 80%;
  margin-right: 10px;
}

.delete-button {
  background-color: #e01c1c;
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
}

.server-button:hover {
  background-color: #45a049;
  transform: scale(1.05);
}

.delete-button:hover {
  background-color: #a70e0e;
  transform: scale(1.05);
}

.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.confirm-popup {
  background: white;
  padding: 20px 30px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  text-align: center;
}

.confirm-popup h3 {
  margin: 0 0 10px;
}

.popup-actions {
  display: flex;
  justify-content: space-around;
  margin-top: 15px;
}

.confirm-button {
  background-color: #e74c3c;
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.cancel-button {
  background-color: #95a5a6;
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.confirm-button:hover {
  background-color: #c0392b;
}

.cancel-button:hover {
  background-color: #7f8c8d;
}

.actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.actions img {
  width: 24px;
  height: 24px;
  object-fit: contain;
  border-radius: 4px;
}
</style>
